import { render, staticRenderFns } from "./staffLayout.vue?vue&type=template&id=1c022a16&scoped=true&"
import script from "./staffLayout.vue?vue&type=script&lang=js&"
export * from "./staffLayout.vue?vue&type=script&lang=js&"
import style0 from "./staffLayout.vue?vue&type=style&index=0&id=1c022a16&scoped=true&lang=css&"
import style1 from "./staffLayout.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c022a16",
  null
  
)

export default component.exports